import styled from '../../../styles/styledComponents/themeComponents';

export const ListBoxStyle = styled.div`
  border: 1px solid #e7eaec;
  background-color: #fff;

  .list-box-head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e7eaec;
    padding: 25px;

    .list-total-cnt {
      font-size: 15px;
      font-weight: 600;
      span {
        color: #6200ea;
      }
    }
  }

  .list-box-body {
    padding: 15px 25px;
  }
`;
